module.exports = __webpack_public_path__ + "img/remove-accessories.e4d968e2.svg";